import { render, staticRenderFns } from "./TemporaryButton.vue?vue&type=template&id=42e65c60&scoped=true&"
import script from "./TemporaryButton.vue?vue&type=script&lang=js&"
export * from "./TemporaryButton.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryButton.vue?vue&type=style&index=0&id=42e65c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e65c60",
  null
  
)

export default component.exports